import React from "react";
import PropTypes from "prop-types";
import { usePermissions } from "context/PermissionsContext";

const WithPermission = ({ permission, userPermission, children }) => {
  const { hasPermission, userHasPermission } = usePermissions();

  if (userPermission) {
    return userHasPermission(userPermission) ? children : null;
  } else {
    return hasPermission(permission) ? children : null;
  }
};

WithPermission.propTypes = {
  permission: PropTypes.string.isRequired,
  userPermission: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default WithPermission;
